module.exports = __webpack_public_path__ + "static/media/trashwavlogo.8f048e23.png";